var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWishlistIconFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 34,
  height: 32,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17.5.5h-.8C8.14.5 1.2 7.44 1.2 16c0 8.56 6.94 15.5 15.5 15.5h.8C26.06 31.5 33 24.56 33 16 33 7.44 26.06.5 17.5.5Z",
  fill: "#F2F0EC"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.5.5h-.8C8.14.5 1.2 7.44 1.2 16c0 8.56 6.94 15.5 15.5 15.5h.8C26.06 31.5 33 24.56 33 16 33 7.44 26.06.5 17.5.5Z",
  stroke: "#F2F0EC"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.1 11.656c1.155-1.314 3.293-1.85 5.025-.702a3.466 3.466 0 0 1 1.535 2.731c.086 2.476-2.165 4.46-5.608 7.498l-.073.064a1.337 1.337 0 0 1-1.764.006l-.066-.057-.04-.035c-3.421-3.024-5.66-5.003-5.569-7.47a3.468 3.468 0 0 1 1.535-2.737c1.732-1.155 3.87-.612 5.025.702Z",
  fill: "#00546F"
})));
export default SvgWishlistIconFilled;